export enum TextFieldLabels {
    MESSAGE = 'Message',
    FULL_NAME = 'Full Name',
    EMAIL = 'Email',
    MOBILE_NUMBER = 'Mobile Number',
}

export enum TextFieldNames {
    MESSAGE = 'message',
    FULL_NAME = 'name',
    EMAIL = 'email',
    MOBILE_NUMBER = 'mobile',
}
